// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 50px;
}

.footer p {
    background-color: var(--red);
    color: var(--background-color);
    border-radius: 50px;
    font-weight: bold;
    font-size: 17px;
    width: -moz-fit-content;
    width: fit-content;
    padding: 10px 20px;
}

.footer p .copyright {
    font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/style/footer.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,uBAAkB;IAAlB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB","sourcesContent":[".footer {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    margin: 50px;\n}\n\n.footer p {\n    background-color: var(--red);\n    color: var(--background-color);\n    border-radius: 50px;\n    font-weight: bold;\n    font-size: 17px;\n    width: fit-content;\n    padding: 10px 20px;\n}\n\n.footer p .copyright {\n    font-size: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
